export default __webpack_public_path__ + "static/5905v5907_3_thumb-baa5e8e132044da102e4c0bb42c08cda.png";